import type { SeatmapData, SeatmapSeat } from '@/types';

/** Check whether a seat index is in seatsOurs, normalising both sides to Number
 *  because the server may return string indices instead of numbers. */
export function seatsOursIncludes(seatsOurs: (number | string)[], index: number): boolean {
  return seatsOurs.some(s => Number(s) === index);
}

/** Find the closest free (or own) seat within highlight radius of (x, y). Returns -1 if none found. */
export function findClosestFreeSeat(seatmapData: SeatmapData, x: number, y: number, state2: number[], seatsOurs: number[]): number {
  let closest = -1;
  let closestDist = Infinity;

  for (let i = 0; i < seatmapData.seats.length; i++) {
    // Skip seats taken by other sessions (state2[i] > 0) unless this session holds them
    if ((state2[i] ?? 0) > 0 && !seatsOursIncludes(seatsOurs, i)) continue;
    const seat = seatmapData.seats[i];
    const dx = seat.x - x;
    const dy = seat.y - y;
    const dist = Math.sqrt(dx * dx + dy * dy);
    const hlRadius = seat.highlightRadius ?? 20;
    if (dist <= hlRadius * 2 && dist < closestDist) {
      closestDist = dist;
      closest = i;
    }
  }
  return closest;
}

/** Build a human-readable label for a seat (e.g. "Row: A · Seat: 12"). */
export function getSeatLabel(seatmapData: SeatmapData, seat: SeatmapSeat): string {
  const parts: string[] = [];
  const rowLabel = seatmapData.fields[0]?.displayLabel ?? 'Row';
  const seatLabel = seatmapData.fields[1]?.displayLabel ?? 'Seat';
  if (seat.row) parts.push(`${rowLabel}: ${seat.row}`);
  if (seat.seatNumber) parts.push(`${seatLabel}: ${seat.seatNumber}`);
  return parts.join(' · ');
}
